export var REFERRAL_STATUS_DRAFT = 'draft';
export var REFERRAL_STATUS_PENDING = 'pending';
export var DRAFT_REFERRAL_DISPLAY = 'Draft Referral';
export var REFERRAL_DISPLAY = 'Referral';